<script lang="ts" setup>
import Cms from "@/components/Cms.vue";
import { Link } from "@inertiajs/vue3";
import { computed, inject, ref } from "vue";
// import { registeredComponents } from "@root/customer-care-page-init-builder.ts"; 
import { getBuilderComponents } from "@root/builder-components.ts";
import { Head } from "@inertiajs/vue3";
let route = inject('route');
let currentUrl = computed(()=>{
    if(typeof window == 'undefined'){
        return '';
    }
    return window.location.href?.replace(window.origin, '');
});

let builderData = ref({
    pageName: "",
    metaDescription: "",
    metaKeywords: ""
})

let searchParams = computed(()=>{
    return {
        "data.pageUrl.$eq": '/customer-service'
    }
});

let canonicalUrl = computed(()=>{
    return route('customer-service.index');
});
</script>
<template>
    <div>
        <Head>
            <title>{{ builderData.pageName }}</title>
            <meta name="description" :content="builderData.metaDescription" />
            <meta name="keywords" :content="builderData.metaKeywords" />
            <link rel="canonical" :href="canonicalUrl" />
        </Head>
        <div class="contact_us">    
            <h1 role="heading" aria-level="1" class="contact_us-title headline-xl">Contact Us</h1>
            <p class="contact_us-description paragraph-feature">With a dedicated staff of over 150 employees, Rothco is always here to serve you as best we can. Please take a moment to look through our <Link :href="route('customer-service.faqs')" class="paragraph-feature">Frequently Asked Questions (FAQs)</Link> to see if your question has been answered there.</p>
            <Cms v-model="builderData" :readable-fields="['pageName', 'metaDescription', 'metaKeywords']" model="content-section" :url="currentUrl" driver="builder" is-section :components="getBuilderComponents()" :search-params="searchParams" />
        </div>
    </div>
</template>